export default function(userId, type) {
  const body = {
    /* eslint-disable @typescript-eslint/camelcase */
    free_limitations_add_count: 0,
    free_limitations_copy_count: 0,
    free_limitations_edit_count: 0,
    free_limitations_move_count: 0,
    free_limitations_user_id: userId,
    /* eslint-enable */
  }

  body[type] = 1
  return body
}
